export default __webpack_public_path__ + "static/media/social-03@2x.18a78868.jpg";